
import React, { useState } from "react";

const Subscribe = () => {
  const [loading, setLoading] = useState(false);

  // URL PARAMS
  const params = new URLSearchParams(window.location.search);

  const ext_ref = params.get("ext_ref") || "";
  const partner = params.get("partner") || "prop";

  // SUBSCRIBE
  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   setLoading(true);

  //   window.location.replace(
  //     `https://dsdp-cg.safaricom.com/consent-gateway/001023836945`
  //   );
  // };

  const handleSubmit = (e) => {
  e.preventDefault();

  setLoading(true);

  window.location.replace(
    `https://dsdp-cg.safaricom.com/consent-gateway/001023836945?ext_ref=${encodeURIComponent(ext_ref)}`
  );
};

  return (
    <div className="min-h-screen bg-[#07080A] flex flex-col items-center justify-center p-5 relative font-sans">
      {/* Subtle Grid Pattern Overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.015)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.015)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none z-0" />

      {/* Main Solid Dark Card with Border and Glow */}
      <form
        onSubmit={handleSubmit}
        className="bg-[#12131A] rounded-[32px] border border-white/10 shadow-[0_0_40px_rgba(255,238,0,0.08)] p-10 sm:p-14 w-full max-w-[440px] relative z-10 flex flex-col items-center"
      >
        {/* LOGO */}
        <div className="flex justify-center mb-8 relative">
          <div className="absolute inset-0 bg-[#FFEE00]/40 blur-[40px] rounded-full scale-[2] z-0 pointer-events-none" />

          <svg
            className="w-20 h-20 relative z-10 drop-shadow-[0_0_10px_rgba(255,238,0,0.8)]"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20,62 C18,48 24,35 44,32 C48,31.5 52,31.5 56,32 C76,35 82,48 80,62 C78,74 71,83 60,80 C54,78.5 46,78.5 40,80 C29,83 22,74 20,62 Z"
              fill="#FFEE00"
            />
            <path
              d="M41,80 C44,77.5 56,77.5 59,80 C55,73 45,73 41,80 Z"
              fill="#12131A"
            />
            <rect
              x="29"
              y="52"
              width="9"
              height="3"
              rx="1.2"
              fill="#FF007F"
            />
            <rect
              x="32"
              y="49"
              width="3"
              height="9"
              rx="1.2"
              fill="#FF007F"
            />
            <circle cx="64" cy="52" r="2.2" fill="#FF007F" />
            <circle cx="70" cy="56" r="2.2" fill="#FF007F" />
            <circle cx="67" cy="47" r="2.2" fill="#FF007F" />
            <path d="M32,27 L39,12 L50,21 L61,12 L68,27 Z" fill="#FFEE00" />
            <circle cx="50" cy="9" r="3.2" fill="#FFEE00" />
            <circle cx="39" cy="10" r="2.2" fill="#FFEE00" />
            <circle cx="61" cy="10" r="2.2" fill="#FFEE00" />
          </svg>
        </div>

        {/* TITLE */}
        <h1
          className="text-3xl sm:text-[36px] font-black text-center uppercase tracking-widest mb-3"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          <span className="text-white">GAMES</span>
          <span className="text-[#005DAA]">GALLERIA</span>
        </h1>

        {/* DESCRIPTION */}
        <p className="text-center text-[10px] sm:text-[11px] font-bold text-[#000000] uppercase tracking-[0.2em] leading-relaxed mb-10">
          UNLIMITED KIDS VIDEOS
          <br />
          FUN LEARNING EXPERIENCE
        </p>

        {/* PRICE BOX */}
        <div className="bg-[#0A0A0F] border border-white/5 rounded-[20px] w-full py-8 mb-8 flex flex-col items-center justify-center">
          <span className="text-[10px] text-[#8A8B95] font-black uppercase tracking-widest mb-2">
            PRICE
          </span>

          <h2
            className="text-center text-[#005DAA] text-3xl font-black tracking-wide drop-shadow-[0_0_10px_rgba(255,0,127,0.3)]"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            15KSH{" "}
            <span className="text-sm text-[#8A8B95] font-sans tracking-normal font-bold">
              /Daily
            </span>
          </h2>
        </div>

        {/* BUTTON */}
        <button
          type="submit"
          disabled={loading}
          className={`w-full text-[14px] sm:text-[15px] font-black uppercase tracking-[0.2em] py-3 rounded-2xl transition-all duration-300 flex items-center justify-center gap-3 bg-gradient-to-r from-[#005DAA] to-[#FFCC00] text-black ${
            loading
              ? "opacity-60 cursor-not-allowed shadow-[0_0_15px_rgba(255,238,0,0.1)]"
              : "hover:to-[#FFEE00] hover:scale-[1.02] active:scale-[0.98] cursor-pointer shadow-[0_0_30px_rgba(255,238,0,0.3)] hover:shadow-[0_0_40px_rgba(255,238,0,0.5)]"
          }`}
        >
          {loading ? (
            <>
              <span className="animate-spin h-5 w-5 rounded-full border-[3px] border-black border-t-transparent" />
              REDIRECTING...
            </>
          ) : (
            "SUBSCRIBE"
          )}
        </button>
      </form>
    </div>
  );
};

export default Subscribe;